export enum DocumentSent {
  NotSentYet = 'notSentYet',
  WithCandidate = 'withCandidate',
  WithEmployer = 'withEmployer',
}
